// بيانات الأسئلة الشائعة
export const faqData = [
  {
    id: 1,
    question: "ما هي جودة الأقمشة المستخدمة؟",
    answer: "نحن نستخدم أجود أنواع الأقمشة المختارة بعناية لضمان الراحة والأناقة والمتانة."
  },
  {
    id: 2,
    question: "هل تتوفر مقاسات كبيرة؟",
    answer: "نعم، نوفر تشكيلة متنوعة من المقاسات لتناسب جميع الأجسام. يرجى مراجعة وصف كل منتج."
  },
  {
    id: 3,
    question: "هل الدفع عند الاستلام؟",
    answer: "نعم، الدفع عند الاستلام متوفر في جميع الولايات لضمان رضاكم التام."
  },
  {
    id: 4,
    question: "هل التوصيل متوفر في جميع الولايات؟",
    answer: "نعم، نوصل لجميع ولايات الجزائر الـ 58 مع خدمة توصيل سريعة."
  },
  {
    id: 5,
    question: "كم المدة حتى يصل الطلب؟",
    answer: "عادة ما يصل الطلب خلال 2 إلى 5 أيام عمل حسب الولاية."
  }
];

// دالة لإنشاء رسالة واتساب عامة
export const createGeneralWhatsappMessage = () => {
  const message = "أرغب بطلب — أحتاج مساعدة";
  return encodeURIComponent(message);
};

// دالة لإنشاء رابط واتساب عام
export const createGeneralWhatsappUrl = (whatsappNumber = "2130657362317") => {
  const message = createGeneralWhatsappMessage();
  return `https://wa.me/${whatsappNumber}?text=${message}`;
};
